import { Dialog, useDialog } from "@fpsoftware/mvp";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { TbDeviceFloppy } from "react-icons/tb";
import { MortgagePatchBodySchema } from "shared";
import { Api } from "@/api.config";
import { Button } from "@/components/Button";
import { DebtListFields } from "@/components/form/DebtListFields";
import { QueryKeys } from "@/LinkGen";
import { useMortgage } from "@/mortgages/hooks";

interface EditMortgageDebtsDialogProps {
  mortgageID: number;
}

export const EditMortgageDebtsDialog = (
  props: EditMortgageDebtsDialogProps,
) => {
  const dialog = useDialog();
  const mortgage = useMortgage(props.mortgageID);

  const { handleSubmit, formState, control } = useForm({
    resolver: zodResolver(MortgagePatchBodySchema.pick({ debts: true })),
    defaultValues: {
      debts: mortgage.remortgage.debts.map((debt) => ({
        type: debt.type,
        name: debt.name,
        balance: debt.balance,
        interest_rate: debt.interestRate,
        monthly_payment: debt.monthlyPayment,
      })),
    },
  });
  const queryClient = useQueryClient();

  const onSubmit = handleSubmit(async (values) => {
    await Api.MortgagePatch(props.mortgageID, values);

    await queryClient.refetchQueries({
      queryKey: QueryKeys.Mortgage(props.mortgageID),
    });
    dialog.close();
  });

  return (
    <form onSubmit={onSubmit}>
      <Dialog.Header>Other loans to pay off</Dialog.Header>
      <Dialog.Body>
        <DebtListFields control={control} name="debts" />
      </Dialog.Body>
      <Dialog.Footer>
        <Button
          icon={TbDeviceFloppy}
          type="submit"
          loading={formState.isSubmitting}
        >
          Save
        </Button>
      </Dialog.Footer>
    </form>
  );
};
